export const CATEGORY_LIST_REQUEST = "CATEGORY_LIST_REQUEST";
export const CATEGORY_LIST_SUCCESS = "CATEGORY_LIST_SUCCESS";
export const CATEGORY_LIST_FAIL = "CATEGORY_LIST_FAIL";
export const CATEGORY_LIST_RESET = "CATEGORY_LIST_RESET";

export const CATEGORY_DETAILS_REQUEST = "CATEGORY_DETAILS_REQUEST";
export const CATEGORY_DETAILS_SUCCESS = "CATEGORY_DETAILS_SUCCESS";
export const CATEGORY_DETAILS_FAIL = "CATEGORY_DETAILS_FAIL";
export const CATEGORY_DETAILS_RESET = "CATEGORY_DETAILS_RESET";

export const ADMIN_CATEGORY_LIST_REQUEST = "ADMIN_CATEGORY_LIST_REQUEST";
export const ADMIN_CATEGORY_LIST_SUCCESS = "ADMIN_CATEGORY_LIST_SUCCESS";
export const ADMIN_CATEGORY_LIST_FAIL = "ADMIN_CATEGORY_LIST_FAIL";
export const ADMIN_CATEGORY_LIST_RESET = "ADMIN_CATEGORY_LIST_RESET";

export const ADMIN_CATEGORY_DETAILS_REQUEST = "ADMIN_CATEGORY_DETAILS_REQUEST";
export const ADMIN_CATEGORY_DETAILS_SUCCESS = "ADMIN_CATEGORY_DETAILS_SUCCESS";
export const ADMIN_CATEGORY_DETAILS_FAIL = "ADMIN_CATEGORY_DETAILS_FAIL";
export const ADMIN_CATEGORY_DETAILS_RESET = "ADMIN_CATEGORY_DETAILS_RESET";

export const ADMIN_CATEGORY_CREATE_REQUEST = "ADMIN_CATEGORY_CREATE_REQUEST";
export const ADMIN_CATEGORY_CREATE_SUCCESS = "ADMIN_CATEGORY_CREATE_SUCCESS";
export const ADMIN_CATEGORY_CREATE_FAIL = "ADMIN_CATEGORY_CREATE_FAIL";
export const ADMIN_CATEGORY_CREATE_RESET = "ADMIN_CATEGORY_CREATE_RESET";

export const ADMIN_CATEGORY_UPDATE_REQUEST = "ADMIN_CATEGORY_UPDATE_REQUEST";
export const ADMIN_CATEGORY_UPDATE_SUCCESS = "ADMIN_CATEGORY_UPDATE_SUCCESS";
export const ADMIN_CATEGORY_UPDATE_FAIL = "ADMIN_CATEGORY_UPDATE_FAIL";
export const ADMIN_CATEGORY_UPDATE_RESET = "ADMIN_CATEGORY_UPDATE_RESET";

export const ADMIN_CATEGORY_DELETE_REQUEST = "ADMIN_CATEGORY_DELETE_REQUEST";
export const ADMIN_CATEGORY_DELETE_SUCCESS = "ADMIN_CATEGORY_DELETE_SUCCESS";
export const ADMIN_CATEGORY_DELETE_FAIL = "ADMIN_CATEGORY_DELETE_FAIL";
export const ADMIN_CATEGORY_DELETE_RESET = "ADMIN_CATEGORY_DELETE_RESET";

export const CATEGORY_CLEAR_ERROR = "CATEGORY_CLEAR_ERROR";
export const ADMIN_CATEGORY_CLEAR_ERROR = "ADMIN_CATEGORY_CLEAR_ERROR";
